<template>
	<div class="appContainer">
		<div class="container">
			<div class="mb-4 d-inline-block w-100 pt-2">
				<img class="logo-pagbrasil mt-2" src="~@/assets/img/logos/pagbrasil.svg">
			</div>
			<div class="w-100 mb-4 noprint boletonotfound">
				Boleto não encontrado.
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'BoletoNotFound',
	data(){
		return{}
	},

	components: {},

	mounted: function(){},

	computed: {}
}

</script>